import { Grid, } from "@mui/material";
import SimulationCollectionTable from "./SimulationCollectionTable";

// ==============================|| SIMULATION COLLECTIONS - DEFAULT ||============================== //

const SimulationCollectionDefault = () => {

    return (
        <Grid container rowSpacing={4.5} columnSpacing={2.75}>
            <Grid item xs={12} md={12} lg={12}>
                <SimulationCollectionTable type={'edit'} />
            </Grid>
        </Grid>
    );
};

export default SimulationCollectionDefault;